var map = {
  "./cs.json": [
    "smC",
    [
      "a64"
    ]
  ],
  "./en.json": [
    "ri",
    [
      "1q"
    ]
  ],
  "./pl.json": [
    "Ol",
    [
      "09"
    ]
  ],
  "./ru.json": [
    "VeX",
    [
      "vex"
    ]
  ],
  "./tr.json": [
    "Zo8",
    [
      36
    ]
  ],
  "./ja.json": [
    "ZZO",
    [
      "zb"
    ]
  ],
  "./zh.json": [
    "CG0",
    [
      "km"
    ]
  ],
  "./pt-br.json": [
    "T2",
    [
      "9rv"
    ]
  ],
  "./de.json": [
    "Wa7",
    [
      "cr"
    ]
  ],
  "./es.json": [
    "wNV",
    [
      "ezg"
    ]
  ],
  "./fr.json": [
    "haK",
    [
      "brg"
    ]
  ],
  "./it.json": [
    "Wnq",
    [
      "sah"
    ]
  ],
  "./ko.json": [
    "uTJ",
    [
      868
    ]
  ],
  "./pt.json": [
    "AX7D",
    [
      "il"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Vv";
module.exports = __rspack_async_context;
